import { CircularProgress, styled } from '@material-ui/core';
import { palette } from '../../settings/themes/colors';

// TODO: the LoadingCircularProgress component mustn't have a margins for full pages loading
export const LoadingCircularProgress = styled(CircularProgress)({
  color: palette.captudataBlue,
  margin: ' 100px auto 64vh auto'
});
